import { ColorSchemeInterface } from "@/types/ColorSchemeInterface";
import {
  FacadeInterface,
  FacadeInterfaceWithImagesUrls,
} from "@/types/FacadeInterface";

const formatEntityForBuilderSliderImages = <
  T extends FacadeInterfaceWithImagesUrls | ColorSchemeInterface
>(
  entities: T[] | null
): (T & { name: string; id: string; _id: string })[] | null => {
  if (!entities) return null;

  return entities.map((entity: T) => {
    return {
      ...entity,
      name: entity.name,
      id: entity.imagesUrls[0],
      _id: entity._id,
    };
  });
};

export default formatEntityForBuilderSliderImages;
